(function () {
  function formatMoney(cents) {
    const value = cents / 100;
    return value.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
  }

  function uniqueSorted(values) {
    return [...new Set(values.filter(v => v !== "" && v != null))].sort((a,b) => {
      const na = parseFloat(String(a).replace(",", "."));
      const nb = parseFloat(String(b).replace(",", "."));
      if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
      return String(a).localeCompare(String(b), 'nl');
    });
  }

  function initConfigurator(root) {
    const dataEl = root.querySelector('.js-series-products');
    if (!dataEl) return;

    const data = JSON.parse(dataEl.textContent);
    const items = data.items || [];
    if (!items.length) return;

    const currentItem = items.find(i => i.handle === data.currentHandle) || items[0];
    const currentPrice = currentItem.price;

    const keys = [
      { key: "werkhoogte", selectId: "cfg-werkhoogte" },
      { key: "steigerbreedte", selectId: "cfg-steigerbreedte" },
      { key: "platformlengte", selectId: "cfg-platformlengte" },
      { key: "voorloopleuningen", selectId: "cfg-voorloopleuningen" },
      { key: "type_platform", selectId: "cfg-type_platform" }
    ];

    function getSelectedState() {
      const state = {};
      keys.forEach(({key, selectId}) => {
        const select = root.querySelector(`#${selectId}`);
        state[key] = select ? select.value : "";
      });
      return state;
    }

    // Filter producten die exact matchen op alle gekozen velden (behalve excludeKey)
    function filterByState(state, excludeKey) {
      return items.filter(it => {
        return keys.every(({key}) => {
          if (key === excludeKey) return true;
          const val = state[key];
          return !val || it.options[key] === val;
        });
      });
    }

    // Welke waarden zijn geldig voor 1 key, gegeven de rest van de selectie?
    function validValuesForKey(state, key) {
      const candidates = filterByState(state, key);
      return uniqueSorted(candidates.map(c => c.options[key]));
    }

    // Vind exact product voor volledige state (alles matcht)
    function findExactProduct(state) {
      return items.find(it =>
        keys.every(({key}) => it.options[key] === state[key])
      ) || null;
    }

    function diffLabel(targetPrice) {
      const diff = targetPrice - currentPrice;
      if (diff === 0) return `(${formatMoney(0)})`;
      if (diff > 0) return `(+${formatMoney(diff)})`;
      return `(-${formatMoney(Math.abs(diff))})`;
    }

    // Render dropdowns clean of priced
    function renderAll({ priced = false, openedKey = null } = {}) {
      const state = getSelectedState();

      keys.forEach(({key, selectId}) => {
        const select = root.querySelector(`#${selectId}`);
        if (!select) return;

        const values = validValuesForKey(state, key);

        // als huidige waarde ineens ongeldig is (kan gebeuren na andere keuze),
        // val terug op eerste geldige waarde
        let curVal = state[key] || currentItem.options[key];
        if (!values.includes(curVal) && values.length) {
          curVal = values[0];
          select.value = curVal;
          state[key] = curVal;
        }

        select.innerHTML = values.map(v => {
          const selected = (curVal === v);
          let suffix = "";

          // Alleen prijzen tonen:
          // - dropdown moet open zijn EN
          // - het is de dropdown die open is (openedKey) EN
          // - dit is NIET de huidige selectie
          if (priced && openedKey === key && !selected) {
            const tempState = { ...state, [key]: v };
            const target = findExactProduct(tempState) || null;
            if (target) suffix = ` ${diffLabel(target.price)}`;
          }

          return `<option ${selected ? "selected" : ""} value="${String(v).replace(/"/g,'&quot;')}">${v}${suffix}</option>`;
        }).join("");
      });
    }

    function onChange(changedKey) {
      const state = getSelectedState();

      // na change bouwen we alles opnieuw (clean) met valide combinaties
      renderAll({ priced: false });

      const target = findExactProduct(state);
      if (target && target.handle !== data.currentHandle) {
        window.location.href = target.url;
      }
    }

    // init clean
    // eerst preselect current in DOM
    keys.forEach(({key, selectId}) => {
      const select = root.querySelector(`#${selectId}`);
      if (!select) return;
      select.value = currentItem.options[key] || "";
    });

    renderAll({ priced: false });

    // events
    keys.forEach(({key, selectId}) => {
      const select = root.querySelector(`#${selectId}`);
      if (!select) return;

      const wrap = select.closest('.product-addon__select-wrap');

function openSelect() {
  if (wrap) wrap.classList.add('is-open');
  renderAll({ priced: true, openedKey: key });
}

function closeSelect() {
  if (wrap) wrap.classList.remove('is-open');
  renderAll({ priced: false });
}

// Openen (klik/focus)
let wasOpen = false;

select.addEventListener('focus', () => {
  wasOpen = true;
  openSelect();
});

// Dit vangt de "klik om te sluiten" op dezelfde dropdown af
select.addEventListener('mousedown', (e) => {
  // Als hij al open is en je klikt opnieuw op dezelfde select:
  // dan gaat de native dropdown dicht, maar focus blijft -> wij draaien pijltje terug.
  if (wrap && wrap.classList.contains('is-open')) {
    wasOpen = false;
    // een tick later zodat native close eerst gebeurt
    setTimeout(() => closeSelect(), 0);
  } else {
    wasOpen = true;
    openSelect();
  }
});

select.addEventListener('blur', () => {
  wasOpen = false;
  closeSelect();
});

select.addEventListener('change', () => {
  wasOpen = false;
  closeSelect();
  select.blur();
  onChange(key);
});


    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-series-configurator').forEach(initConfigurator);
  });
})();

